import VERIFICAR_TOKEN from '@/graphql/mutations/auth/verificarToken.gql';
import Mensajes from './Mensajes';

export default {
  data: () => ({
    mixReglas: {
      requerido: (value) => !!value || 'Requerido.',
      notNull: (value) => value !== null || 'Requerido.',
      codigoPostal: (value) => {
        const pattern = /^\d{5}$/;
        return pattern.test(value) || 'Codigo postal de 5 números.';
      },
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Correo electronico invalido.';
      },
    },
  }),
  methods: {
    async mixChecarAutentificacion() {
      await this.$apollo
        .mutate({ mutation: VERIFICAR_TOKEN })
        .then(({ data: { verificarToken } }) => {
          const { status, usuario: datosUsuario } = verificarToken;
          const { auth } = this.$route.meta;
          if (verificarToken.status) {
            this.$auth.isAuthenticated = status;
            this.$auth.isLoading = false;
            const {
              id,
              funcionario: { nombre, puesto, esSupervisor },
              correoElectronico,
              avatarPublicKey,
              roles,
              scopes,
            } = datosUsuario;
            this.$auth.user = {
              id,
              correoElectronico,
              nombre,
              puesto,
              esSupervisor,
              avatarPublicKey,
              roles,
              scopes,
            };
          } else if (auth) {
            this.$router.push({ name: 'login' });
          }
        });
    },
    mixEsCargando() {
      this.$store.commit('configuracion/CAMBIAR_IS_CARGANDO');
    },
    mixMensajeSuccess(msg) {
      const respuesta = Mensajes(msg).success;
      this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
    },
    mixMensajeInfo(msg) {
      const respuesta = Mensajes(msg).info;
      this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
    },
    mixMensajeWarning(msg) {
      const respuesta = Mensajes(msg).warning;
      this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
    },
    mixMensajeError(msg) {
      const respuesta = Mensajes(msg).error;
      this.$store.commit('configuracion/MOSTRAR_RESPUESTA', { respuesta });
    },
    mixPaginacion(array, pagina, cantidadRegistrosPorPagina) {
      // Transformar las variables
      let index = Math.abs(parseInt(pagina, 10));
      index = index > 0 ? index - 1 : index;
      let cantidadPaginas = parseInt(cantidadRegistrosPorPagina, 10);
      cantidadPaginas = cantidadPaginas < 1 ? 1 : cantidadPaginas;

      // Regresar los resultados filtrados
      return [
        ...array.filter(
          (value, n) => n >= index * cantidadPaginas && n < (index + 1) * cantidadPaginas,
        ),
      ];
    },
    mixMostrarMas(array, pagina, cantidadRegistrosPorPagina) {
      // Transformar las variables
      let cantidadPaginas = parseInt(cantidadRegistrosPorPagina, 10);
      cantidadPaginas = cantidadPaginas < 1 ? 1 : cantidadPaginas;

      // Regresar los resultados filtrados
      return [...array.filter((value, n) => n <= pagina * cantidadPaginas)];
    },
    mixGuardarFiltros(nombreDelFiltro, filtros) {
      if (!this.$checkLocalStore) return;
      localStorage.setItem(nombreDelFiltro, filtros);
    },
    mixGetFiltro(nombreDelFiltro) {
      if (!this.$checkLocalStore) return null;
      return localStorage.getItem(nombreDelFiltro);
    },
    mixRemoverFiltro(nombreDelFiltro) {
      if (!this.$checkLocalStore) return;
      localStorage.removeItem(nombreDelFiltro);
    },
    mixValidaScopesActions(scope) {
      return this.$auth.validaScopesActions(scope);
    },
  },
};
